import HeroRentalCar from 'shared/lib/assets/img/landing/hero-rental-car.png';
import LogoChubb from 'shared/lib/assets/img/logo/logo-chubb.svg';

export const rentalCarConfig = {
  hero: {
    heading: 'Key Component: Coverage for your rental car',
    subheading:
      'Don’t make an at-the-counter decision on insurance for your rental car. SURE takes the pain out of the process to offer comprehensive coverage at a more affordable rate.',
    cta: 'Get rental car insurance',
    ctaLink: '/rental-car-insurance/rental-info',
    img: HeroRentalCar,
  },
  underwriter: {
    img: LogoChubb,
    name: 'Chubb',
  },
  coverageDetails: [
    {
      heading: 'Theft or Damage to Personal Property',
      subheading:
        'From minor fender-benders to more serious accidents, you’ll be covered for physical damage to the vehicle up to $100,000. Anything that is yours in the car is covered, too.',
    },
    {
      heading: 'Lost Key Reimbursement',
      subheading:
        'Replacing keys is costly business—especially with a rental. The good news: This policy covers the price, so you can stress less.',
    },
    {
      heading: 'Flat Tire Expenses',
      subheading:
        'An errant nail sends you to the shoulder—but the cost of fixing your flat is covered.',
    },
    {
      heading: 'Towing Charges',
      subheading:
        'Mishaps happen on the road, and when you’re in need of a tow you can rest assured that the cost is covered.',
    },
    {
      heading: 'Misfueling Charges',
      subheading:
        'Cover the cost of draining and cleaning, or for accidental damage caused by driving with the wrong fuel.',
    },
  ],
  scenarioDetails: {
    heading: 'Why Would You Need Rental Car Insurance?',
    scenarios: [
      {
        heading: 'Scenario 1',
        subheading:
          'Headed to a wedding, but it’s your tire—not the champagne—that pops, thanks to a nail on the road.',
      },
      {
        heading: 'Scenario 2',
        subheading:
          'Your purse is stolen and you recover everything but the keys to your rental car.',
      },
      {
        heading: 'Scenario 3',
        subheading:
          'In an unfamiliar place, you misread a sign and park your rental in a tow-away zone.',
      },
      {
        heading: 'Scenario 4',
        subheading: 'You think your diesel, but you’re actually regular.',
      },
    ],
  },
  comparison: [
    'Instant quote',
    'Buy and manage your policy in one place',
    'Insurance explained in simple, easy-to-digest way',
    'Mobile',
    'Endorsements',
    'Plan tailored to fit your needs',
  ],
};
